import React from "react";
import {
  Container,
  ContainerProgress,
  LabelContainer,
  ProgressDone,
} from "./style";

export const ProgressBar = ({ value, children }) => {
  return (
    <Container>
      <LabelContainer>
        <span>{children}</span>
        <span>{value}%</span>
      </LabelContainer>
      <ContainerProgress className="progress">
        <ProgressDone className="progress-done" width={value}></ProgressDone>
      </ContainerProgress>
    </Container>
  );
};
